import React from 'react';
import logo from "../logo.svg";

const Welcome = () => {
  return (
    <div className="welcome-content">
        {/* <img src={logo} alt="Logo" className="welcome-app-logo" /> */}
        <h1>Kamionosallasok.com</h1>
        <p>Hirdess vagy Jelentkezz!</p>
    </div>
  );
};

export default Welcome;
